// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageSliderSection_wrapper__XcPBF"};